"use client";
import { useAtom } from "jotai";
import { ContextMenuProps, contextMenuAtom } from "../store/layoutStore";
import styled from "styled-components";
import { useOutsideClick } from "../hooks/useOutsideClick";
import { shadow, threeDots } from "../styles/globalsStyles";
import { defaultTheme } from "../styles/defaultTheme";
import { Button } from "./core/Button";
import { useRouter } from "next/navigation";

import { useCallback } from "react";

export const ContextMenu = () => {
  const [contextMenuData, setContextMenuData] = useAtom(contextMenuAtom);
  const ref = useOutsideClick(() => clearContextMenu());

  const clearContextMenu = useCallback(() => {
    setContextMenuData(null);
  }, [setContextMenuData]);

  const router = useRouter();
  const handleBtnClick = useCallback(
    (item: ContextMenuProps["items"][0]) => {
      if (item.route) {
        router.push(item.route);
      }
      if (item.callback) {
        item.callback();
      }
      clearContextMenu();
    },
    [clearContextMenu, router]
  );

  if (!contextMenuData) return null;
  return (
    <MenuWrapper $pos={contextMenuData.position} ref={ref}>
      {contextMenuData.items.map((item, i) => (
        <ButtonWithElipsis
          key={`${i}--contextmenu--${item.label}`}
          onClick={() => handleBtnClick(item)}
        >
          {item.label}
        </ButtonWithElipsis>
      ))}
    </MenuWrapper>
  );
};

const ButtonWithElipsis = styled(Button)`
  ${threeDots}
`;
const menuSize = 200;
const heightGap = 32;
const MenuWrapper = styled.div<{ $pos: ContextMenuProps["position"] }>`
  z-index: 999999999999;
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: white;
  width: ${menuSize}px;
  height: max-content;
  ${(p) =>
    `top: ${p.$pos.top + heightGap}px;
    left: ${p.$pos.left - menuSize / 2}px;
    `}
  ${shadow}
  /* gap: .5rem; */
  border: 1px solid ${defaultTheme.secondaryColor};
`;
// const MenuItem = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   border-bottom: 1px solid ${defaultTheme.secondaryColor};
//   padding: 0.5rem;
//   color: ${defaultTheme.primaryColor};
//   &:hover {
//     color: ${defaultTheme.tertiaryColor};

//   }
// `;
